export default function Footer() {
    function getCurrentYear() {
        return new Date().getFullYear()
    }
    return (
        <footer className="flex flex-wrap gap-2 justify-between items-center sm:sticky sm:bottom-0 bg-app-default h-footerHeight">
            <section>
                <p className="text-white text-sm">
                    Copyright, Christina Mary Hendrie Trust {getCurrentYear()}
                </p>
            </section>
            <section>
                <ul className="flex gap-2">
                    <li className="inline-block mr-2">
                        <a
                            href="https://www.christinamaryhendrietrust.co.uk/terms-and-conditions"
                            target="_blank"
                            rel="noreferrer"
                            className="text-white text-sm"
                        >
                            Terms and Conditions
                        </a>
                    </li>
                    <li className="inline-block mx-2">
                        <a
                            href="https://www.christinamaryhendrietrust.co.uk/privacy-policy"
                            target="_blank"
                            rel="noreferrer"
                            className="text-white text-sm"
                        >
                            Privacy Policy
                        </a>
                    </li>
                    <li className="inline-block mx-2">
                        <a
                            href="https://www.christinamaryhendrietrust.co.uk/privacy-policy"
                            target="_blank"
                            rel="noreferrer"
                            className="text-white text-sm"
                        >
                            Cookies
                        </a>
                    </li>
                </ul>
            </section>
        </footer>
    )
}
